import { useEffect, useState } from "react"
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { get, getDatabase, onValue, ref } from "firebase/database"
import { useParams } from "react-router"
import {
  CounterObject,
  ExtendedCounter,
  StandardCounter,
  TCBackCounter,
} from "../types/CounterTypes"
import Extended from "./Counters/Extended"
import Standard from "./Counters/Standard"
import TCBack from "./Counters/TCBack"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-zsF1AdGcb5tg9Vo6bB1usgiK3VoiQ5c",
  authDomain: "kfk-environment.firebaseapp.com",
  databaseURL:
    "https://kfk-environment-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kfk-environment",
  storageBucket: "kfk-environment.appspot.com",
  messagingSenderId: "209981891412",
  appId: "1:209981891412:web:dd288e5984c387af509ec1",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

export default function Counter() {
  const { id } = useParams()
  const [counterObject, setCounterObject] = useState<CounterObject | null>()

  const init = async () => {
    const counter = await get(ref(db, `counters/${id}`))
    if (counter.exists()) {
      setCounterObject(counter.val())
      onValue(ref(db, `counters/${id}`), (snapshot) => {
        const data = snapshot.val()
        setCounterObject(data)
      })
    } else {
      console.log("No data available")
    }
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="bg-slate-900 w-full h-fit min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xs w-full flex flex-col gap-6 my-6">
        {counterObject ? (
          counterObject.type === "standard" ? (
            <Standard
              id={id!}
              object={counterObject as typeof StandardCounter}
            />
          ) : counterObject.type === "extended" ? (
            <Extended
              id={id!}
              object={counterObject as typeof ExtendedCounter}
            />
          ) : counterObject.type === "tc-back" ? (
            <TCBack id={id!} object={counterObject as typeof TCBackCounter}/>
          ) : (
            <div>Undefined Counter Type</div>
          )
        ) : (
          <div></div>
        )}
        <p className="text-white font-semibold">Id: {id}</p>
        <a href="/" className="text-blue-500 underline">
          Hem
        </a>
      </div>
    </div>
  )
}
